import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';
import { api } from '../../lib/api';

export default function GoogleCallback() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login } = useAuthStore();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const handleCallback = async () => {
            const token = searchParams.get('token');
            const err = searchParams.get('error');

            if (err) {
                setError('Google authentication failed.');
                setTimeout(() => navigate('/login'), 3000);
                return;
            }

            if (token) {
                try {
                    localStorage.setItem('auth_token', token);
                    
                    // Fetch user info using the token
                    // Assuming you have a /api/auth/me endpoint like NestJS did
                    const response = await fetch(`${import.meta.env.VITE_API_URL || '/api'}/auth/me`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (!response.ok) {
                        throw new Error('Failed to fetch user profile');
                    }

                    const user = await response.json();
                    
                    login(token, user);
                    navigate('/dashboard');
                } catch (e: any) {
                    console.error(e);
                    setError('Failed to load user profile after Google login.');
                    setTimeout(() => navigate('/login'), 3000);
                }
            } else {
                setError('No token provided.');
                setTimeout(() => navigate('/login'), 3000);
            }
        };

        handleCallback();
    }, [searchParams, navigate, login]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
                {error ? (
                    <div className="text-red-500 mb-4">{error}</div>
                ) : (
                    <div className="text-blue-600 mb-4 animate-pulse">Authenticating with Google...</div>
                )}
                <div className="text-gray-500 text-sm">Please wait while we log you in.</div>
            </div>
        </div>
    );
}
